(function($, undefined) {
	
	'use strict';
	var utils;
	var toggleAdminListDetailBtn;
	var deletePersonBtn;
	var deleteAltBtn;
	var confirmBeforeDeleteItemPopup;

	
	var toggleAdminListDetail = function() {
		var ctn = $(this).closest('.admin-list-row');
		ctn.next().slideToggle(300);
		ctn.toggleClass('selected');
	};
	
	var showDeleteConfirmationPopup = function(e) {
		e.stopPropagation();
		var t = $(this);
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-id', t.attr('data-id'));
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-type', t.attr('data-type'));
		confirmBeforeDeleteItemPopup.addClass('visible');
	};
	
	var onDeleteItemPopupConfirm = function() {
		var t = $(this);
		var parent = t.closest('.popup-inner');
		parent.addClass('processing');
		var type = t.attr('data-type');
		
		if (type === "person") {
			utils.deletePerson(t.attr('data-id'), function(response) {
				if (response.indexOf('success') !== -1) {
					location.reload();
				} else {
					parent.removeClass('processing');
				}
			});
		} 
		else if (type === "student") {
			utils.deleteStudent(t.attr('data-id'), function(response) {
				if (response.indexOf('success') !== -1) {
					location.reload();
				} else {
					parent.removeClass('processing');
				}
			});
		}
		else if (type === "gendata") {
			utils.deleteGenData(t.attr('data-id'), function(response) {
				if (response.indexOf('success') !== -1) {
					location.reload();
				} else {
					parent.removeClass('processing');
				}
			});
		} else {
			console.log('unrecognized data type: ' + type);
		}
	};
	
	var updateSort = function() {
		var btn = $(this);
		var fieldToSort = btn.attr('data-field');
		var sortOrder = !btn.hasClass('asc') ? 'asc' : 'desc';
		
		var updatedParams = replaceOrAddUrlParams([['sortBy', fieldToSort], ['sortOrder', sortOrder]]);
		replaceParamsInUrl(updatedParams);
	};
	
	var getUrlParams = function() {
		var currentHref = location.href;
		return currentHref.indexOf('?') !== -1 ? currentHref.substr(currentHref.indexOf('?') + 1, currentHref.length - 1) : "";	
	};
	
	var getUrlParamsArray = function() {
		var paramsString = getUrlParams();
		if (paramsString.length === 0) { return []; }
		
		var params = paramsString.split('&');
		return params.map(function(param) {
			return {
				"key": param.split('=')[0],
				"value": param.split('=')[1]
			};
		});
	};
	
	var replaceOrAddUrlParams = function(newParamsArray) {
		var paramsArray = getUrlParamsArray();
		var newParams = "";
		
		newParams = paramsArray.map(function(param) {
			var newParam = param;
			for (let i in newParamsArray) {
				var key = newParamsArray[i][0];
				var value = newParamsArray[i][1];
				
				if (param.key === key) {
					newParam.value = value;
				}
			}
			
			return newParam.key + '=' + newParam.value;
		}).join('&');
		
		for (let i in newParamsArray) {
			var key = newParamsArray[i][0];
			var value = newParamsArray[i][1];
			if (newParams.indexOf(key) === -1) {
				var prefix = newParams.length > 0 ? '&' : '?';
				newParams += prefix + key + '=' + value;
			}
		}
		return newParams;
	};
	
	var replaceParamsInUrl = function(newParams) {
		if (newParams.indexOf('?') === -1) { newParams = '?' + newParams; }
		var currentHref = location.href;
		var endSubstrIndex = currentHref.indexOf('?') !== -1 ? currentHref.indexOf('?') : currentHref.length;
		var newHref = currentHref.substr(0, endSubstrIndex) + newParams;
		window.location.href = newHref;
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		
		toggleAdminListDetailBtn = $('.admin-list-toggle-detail-btn');
		deletePersonBtn = $('.admin-list .delete-item-btn');
		deleteAltBtn = $('.alt-admin-box .delete-item-btn');
		confirmBeforeDeleteItemPopup = $('#admin-confirm-delete-item-popup');
		
		toggleAdminListDetailBtn.on('click', toggleAdminListDetail);
		deletePersonBtn.on('click', showDeleteConfirmationPopup);
		deleteAltBtn.on('click', showDeleteConfirmationPopup);
		$('.delete-btn', confirmBeforeDeleteItemPopup).on('click', onDeleteItemPopupConfirm);
		
		$('.list-sort-btn').on('click', updateSort);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
